import FlightEditForm from "../../components/main/body/screens/IAM/Flights/FlightEditForm";
import { APIs } from "../../util/api/APIs";
import SafeairManager from "../../util/api/SafeairManager";



export default class MedicalKitService {
  static async getMedicalKit() {
    const apiConfig = {
      api: APIs.MedicalKit.getMedicalKit,
      parameters: null,
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data;
  }
  static async getCreateKit() {
    const apiConfig = {
      api: APIs.MedicalKit.getCreateKit,
      parameters: null,
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res.data;
  }
  static async createKit( flightId: string,item:string) {
    const apiConfig = {
      api: APIs.MedicalKit.CreateKit,
      parameters: {
        "flightId": flightId,
        "item": item
      },
      body: null
    };
    const res = await SafeairManager.invoke(apiConfig);
    return res.data;
  }
  static async getAddCreateKit(mKitId: string,expiryDate:string, flightId: string,items:Items[]) {
    const apiConfig = {
      api: APIs.MedicalKit.AddCreateKit,
      parameters: null,
      body: {
        id: mKitId,
        expiryDate:expiryDate,
        flightId:flightId,
        items:items,
      },
    };
    const res = await SafeairManager.invoke(apiConfig);
    return res.data;
  }
  static async getEditKit(id:string) {
    const apiConfig = {
      api: APIs.MedicalKit.EditKit,
      parameters: {
  "id":id
      },
      body: null
    }
    const res = await SafeairManager.invoke(apiConfig);
    // alert(JSON.stringify(res.data))
    return res.data;
  }

  static async pdfLink(){
    const apiConfig = {
      api: APIs.MedicalKit.getMedicalKitPdfLink,
      parameters: {
        "value": "true"
      },
      body: null,
    }
    const res = await SafeairManager.invoke(apiConfig);
    return res
  }
  
  static async updateKitEdit(id: string,expiryDate:string){
    const apiConfig = {
      api: APIs.MedicalKit.UpdateKit,
      parameters:null,
      body: {
         id,
         expiryDate
      },
    };
    const response = await SafeairManager.invoke(apiConfig);
    return;
  }
  
  static async getMedicalKitByOrgId(id:string) {
    try{
      const apiConfig = {
        api: APIs.MedicalKit.getMedicalKitByOrgId,
        parameters: {
          "id":id
        },
        body:null
      };
      const res = await SafeairManager.invoke(apiConfig)
      return res
    } catch(err){
      console.log(err)
    }
    
  }

}

interface Items {
  id?: string,
  name?: string
}